export default "__VITE_PUBLIC_ASSET__69dd2083__"